/** Šířka levého labelu (inline layout) sdílená všemi poli formulářů submodulu Schemas — zarovnání sloupce. */
export const FORM_LABEL_WIDTH = 172;
